import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { useSnackbar } from "notistack";

import { ModalBody, ModalFooter } from "application/modal/index";

import { useS3FileUpload, useModelPopup } from "common/hooks";
import { addDocument } from "common/actions/common.action";
import DragAndDrop from "common/components/dragAndDrop";
import { getFilename } from "modules/admin/adminCompanies/editCompany/editCompany.helper";

import { Button, BtnType, Loading } from "../../../../../primitives";
import styles from "../document.module.scss";

const UploadDocumentFile = () => {
  const {
    authReducer: { session },
    councilReducer: { selectedCouncil },
    projectsReducer: {
      projectReducer: { selectedProject },
    },
    documentsReducer: { loadingDocs },
  } = useSelector((state) => state);

  const popup = useModelPopup();
  const [forbiddenFiles, setForbiddenFiles] = useState([]);
  const { fileUpload } = useS3FileUpload();
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [uploadValues, setUploadValues] = useState([]);
  const [documents, setDocuments] = useState([]);

  const savedocument = () => {
    const obj = {
      description: "",
      name: documents[0].name,
      s3url: documents[0].uri,
      councilId: selectedCouncil.id,
      document_resource_type: "Project",
      document_resource_id: selectedProject.id,
      added_by_id: session.id,
      enqueueSnackbar,
      upload_type: "file",
    };
    dispatch(addDocument(obj));
  };

  const uploadHandler = async (e, action) => {
    if (forbiddenFiles.length) {
      setForbiddenFiles([]);
    }

    let files;

    if (action === "click") {
      if (!e || !e.target.files.length) {
        return;
      }

      files = Array.from(e.target.files);
    }

    if (action === "drop") {
      if (!e || !e.files.length) {
        return;
      }

      files = Array.from(e.files);
    }

    if (!files) {
      return;
    }

    const fileList = [];
    let dismissedFiles = 0;

    setLoading(true);
    setUploadValues((items) => {
      const currentFiles = [...items];

      const newFiles = files.map((file) => ({
        progress: 0,
        name: file.name,
      }));
      return [...currentFiles, ...newFiles];
    });

    files.forEach(async (file) => {
      if (file.size <= 10000000) {
        const pathname = `srm/${selectedCouncil.id}/${"projects"}/${
          selectedProject.id
        }/documents`;
        await fileUpload(file, pathname, setUploadValues, file.name).then(
          (res) => {
            if (res && res.location) {
              if (
                documents?.indexOf(res.location) === -1 ||
                documents?.indexOf(res.location) === undefined
              ) {
                fileList.push(res.location);
                setLoading(false);
                if (fileList.length === files.length - dismissedFiles) {
                  setDocuments([
                    ...fileList.map((uri) => ({
                      uri,
                      name: getFilename(uri),
                      council_id: selectedCouncil.id,
                      added_by_id: session.id,
                    })),
                  ]);
                }
              } else {
                enqueueSnackbar("This document was already added.", {
                  variant: "error",
                });
                setLoading(false);
                dismissedFiles++;
                setForbiddenFiles((prevFiles) => {
                  const localFiles = [...prevFiles];
                  localFiles.push({
                    name: file.name,
                    error: "Document already added.",
                  });
                  return localFiles;
                });
                setUploadValues((prevState) => {
                  const currentProgress = [...prevState];
                  const index = currentProgress
                    .map((item) => item.name)
                    .lastIndexOf(file.name);
                  currentProgress[index] = {
                    progress: "NOT_ALLOWED",
                    name: file.name,
                  };
                  return currentProgress;
                });
              }
            }
          }
        );
      } else {
        setUploadValues((prevState) => {
          const currentProgress = [...prevState];
          const index = currentProgress.findIndex(
            (item) => item.name === file.name
          );
          currentProgress[index] = {
            progress: "NOT_ALLOWED",
            name: file.name,
          };
          return currentProgress;
        });
        setLoading(false);
        if (file.size > 10000000) {
          dismissedFiles++;
          setLoading(false);
          setForbiddenFiles((prevFiles) => {
            const localFiles = [...prevFiles];
            localFiles.push({
              name: file.name,
              error: "Your file is too large. File size limit: 100MB",
            });
            return localFiles;
          });
          enqueueSnackbar(
            "We could not upload your document because your file size is too big. Please make sure the file is less than 100 MB",
            {
              variant: "error",
            }
          );
        }
      }
    });

    e.target.value = "";
  };

  // if (loading) {
  //   return <Loading />;
  // }
  return (
    <div>
      <ModalBody>
        <div>
          {" "}
          <div className={styles.dropBoxContainer}>
            <div className={styles.dragAndDropContainer}>
              <DragAndDrop
                uploadHandler={uploadHandler}
                loading={loading}
                customText="drag and drop a document here"
              />
            </div>
            {documents?.length
              ? documents.map((doc) => {
                  return (
                    <span className={styles.forbiddenfileName}>
                      {`${doc.name} `}
                    </span>
                  );
                })
              : null}
            {forbiddenFiles?.length ? (
              <div className={styles.forbiddenfileContainer}>
                Files that weren't allowed:{" "}
                {forbiddenFiles.map((file) => (
                  <span className={styles.forbiddenfileName}>
                    {`${file.name}: `}
                    <span className={styles.errorText}> {file.error}</span>
                  </span>
                ))}
              </div>
            ) : null}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => {
            popup.hide();
          }}
          btn={BtnType.FRAME_LESS}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            popup.hide();
            savedocument();
          }}
        >
          Upload
        </Button>
      </ModalFooter>
    </div>
  );
};

export default UploadDocumentFile;
